import { DashboardWidgetResponse } from '../../../../../../types/api/endpoints/stats/dashboard.types';
import { STATS_ENDPOINTS } from '../../../../../../utils/api/endpoints/statsEndpoints';

export const DASHBOARD_DIR_WIDGET_QUERY_KEY = 'DASHBOARD_DIR_WIDGET';

const PREFIX = '[dashboardDIRWidgetQuery]';

export const queryDashboardDIRWidget = async () => {
  console.log(PREFIX, `Fetching dashboard DIR widget...`);
  const response = await STATS_ENDPOINTS.dashboardDIRWidget();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received dashboard DIR widget.`);
  return json as DashboardWidgetResponse;
};
